/**
 * Generic file type constants used across the platform.
 *
 * These constants are used by extensions (Cursor, VSCode, Claude) and
 * the backend to indicate special file events or types.
 */
/**
 * File types for scan payloads and file events.
 */
export const FILE_TYPES = {
    DELETED: 'file-deleted',
    AI_INSTRUCTION: 'ai_instruction',
    // KIR-3157: content returned by an MCP tool call, forwarded by the endpoint
    // agent / Cowork hook for hidden-unicode analysis (KIR-3909 removed the
    // ai-instructions leg: tool output is not an instruction file).
    MCP_TOOL_RESPONSE: 'mcp-tool-response',
    HOOK: 'hook',
};
//# sourceMappingURL=file-types.js.map